/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ displayName: NonNullable<unknown> }} Settings_Integrations_Zotero_Connected_AsInputs */

const en_settings_integrations_zotero_connected_as = /** @type {(inputs: Settings_Integrations_Zotero_Connected_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Connected as ${i?.displayName}`)
};

const es_settings_integrations_zotero_connected_as = /** @type {(inputs: Settings_Integrations_Zotero_Connected_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conectado como ${i?.displayName}`)
};

/**
* | output |
* | --- |
* | "Connected as {displayName}" |
*
* @param {Settings_Integrations_Zotero_Connected_AsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_integrations_zotero_connected_as = /** @type {((inputs: Settings_Integrations_Zotero_Connected_AsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Integrations_Zotero_Connected_AsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_integrations_zotero_connected_as(inputs)
	return en_settings_integrations_zotero_connected_as(inputs)
});